import { Icon, Spinner, SpinnerSize, Stack, Text, useTheme } from "@fluentui/react"
import { fadeIn } from "global/Application";

export enum ESpinnerVariant {
    default, spinner, done
}
interface IProps {
    hidden: boolean;
    variant: ESpinnerVariant;
}

const SpinnerNotification: React.FunctionComponent<IProps> = (props) => {
    const theme = useTheme();

    return <div
        className={fadeIn}
        style={{
            display: props.hidden ? 'none' : 'block',
            position: 'fixed',
            bottom: '40px',
            right: '40px',
            zIndex: 1000,
            boxShadow: 'rgb(136, 136, 136) 0px 0px 8px',
            padding: '4px',
            borderRadius: '50px',
            backgroundColor: theme.semanticColors.bodyBackground ?? 'white',
            transition: 'all 0.8s ease'
        }}
    >
        <Stack horizontal verticalAlign='center' tokens={{ childrenGap: '8px' }}>

            {props.variant === ESpinnerVariant.spinner &&
                <>
                    <Spinner styles={{ circle: {} }} size={SpinnerSize.medium} />
                    <Text style={{ marginRight: '8px' }} variant={'smallPlus'}>
                        Saving
                    </Text>
                </>
            }

            {props.variant === ESpinnerVariant.done &&
                <>
                    <Icon iconName="CompletedSolid" style={{ color: 'green',  transition: 'background-color 0.5s ease', fontSize:'16px' }} />
                    <Text style={{ marginRight: '8px' }} variant={'smallPlus'}>
                        Complete
                    </Text>
                </>
            }

        </Stack>
    </div>
}

export default SpinnerNotification;